import { FormEventHandler, useContext, useState } from "react";
import AuthenticationContext from "Authentication/AuthenticationContext.ts";
import sendRequest from "hooks/useAxios";
import { useNavigate } from "react-router";

export default function Login() {
  const { login } = useContext(AuthenticationContext);

  const [userData, setUserData] = useState({ userName: "", password: "" });
  const [errorTxt, setErrorTxt] = useState("");

  const navigate = useNavigate();
  const submit = (event) => {
    event.preventDefault();

    sendRequest("audio/login", {
      mobile: userData.userName,
      password: userData.password,
    }).then((res) => {
      const { data } = res;
      if (+data.status === 1) {
        console.log(data);
        navigate("/");
        login(
          data.token,
          data.result.name,
          data.result.mobile,
          data.result.email,
          data.result.type,
          data.result.id
        );
      } else {
        setErrorTxt("موبایل یا کلمه عبور وارد شده اشتباه می‌باشد.");
      }
    });
  };

  return (
    <div className="d-flex flex-column py-5 px-2 justify-content-center">
      <div
        className="m-auto py-2 px-4  text-light"
        style={{
          backgroundColor: "#fe0000",
          borderTopRightRadius: 10,
          borderTopLeftRadius: 10,
          fontSize: 18,
          fontWeight: 300,
          width: 310,
        }}
      >
        ورود به سایت
      </div>
      <div
        className=" m-auto px-3 py-4 d-flex flex-column"
        style={{
          height: 250,
          width: 310,
          border: "1px solid #fe0000",
          backgroundColor: "#272727",
          borderBottomRightRadius: 10,
          borderBottomLeftRadius: 10,
        }}
      >
        <div className="d-flex flex-wrap ">
          <label className="text-light " style={{ fontSize: 14 }}>
            نام کاربری:
          </label>
          <input
            className="form-control col-6"
            value={userData.userName}
            onChange={(e) => {
              if (!isNaN(e.target.value))
                setUserData((prev) => {
                  return { ...prev, userName: e.target.value };
                });
            }}
          />
        </div>
        <div className="mt-3 d-flex flex-wrap">
          <label className="text-light " style={{ fontSize: 14 }}>
            کلمه عبور:
          </label>
          <input
            className="form-control "
            type="password"
            value={userData.password}
            onChange={(e) => {
              setUserData((prev) => {
                return { ...prev, password: e.target.value };
              });
            }}
          />
        </div>
        <div className="text-danger my-1 ms-2" style={{ fontSize: 12 }}>
          {errorTxt}
        </div>
        <div className="mt-auto ms-auto">
          <button
            className="btn bg-danger text-light"
            style={{ width: 100 }}
            onClick={submit}
          >
            ورود
          </button>
        </div>
      </div>
    </div>
  );
}
